var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.type === "add" ? "新增标签" : "编辑标签",
            visible: _vm.dialogVisible,
            width: "30%",
            "append-to-body": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标签名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入，不超过4字" },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f66c6d",
                          "margin-right": "4px",
                        },
                      },
                      [_vm._v("*")]
                    ),
                    _vm._v("\n          标签图标\n        "),
                  ]),
                  !_vm.isUpload && _vm.dialogVisible
                    ? _c("uploadImage", {
                        attrs: {
                          file: _vm.netLicensePhotoSubpage,
                          code: "custom-flight",
                        },
                        on: { uploadSuccess: _vm.getIcon, remove: _vm.getIcon },
                      })
                    : _c(
                        "div",
                        { staticClass: "flex flex-align-center" },
                        [
                          _c("el-image", {
                            staticStyle: { width: "20px", height: "20px" },
                            attrs: { src: _vm.rowData.icon },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                color: "#3d9ffc",
                                "margin-left": "20px",
                              },
                              on: { click: _vm.handleChange },
                            },
                            [_vm._v("\n            更换\n          ")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "主题色", prop: "color" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入主题色", readonly: "" },
                    model: {
                      value: _vm.ruleForm.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "color", $$v)
                      },
                      expression: "ruleForm.color",
                    },
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.color,
                        expression: "ruleForm.color",
                      },
                    ],
                    staticStyle: {
                      width: "30px",
                      height: "30px",
                      "margin-top": "10px",
                    },
                    attrs: { type: "color" },
                    domProps: { value: _vm.ruleForm.color },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "color", $event.target.value)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "info", loading: _vm.submitLoading },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }